import { ChangeEvent, FC, MutableRefObject, useMemo } from "react";
import { Box, Divider, Pagination, Stack, Table, Theme, useMediaQuery } from "@mui/material";
import { AssignTableBody } from "../assignTableBody";
import { getStyles } from "./styles";
import { AssignTableHead } from "../assignTableHead";

interface IProps {
    scrollRef: MutableRefObject<HTMLDivElement | null>;
    sortedBy: string;
    assignList: any[];
    page: number;
    pageAmount: number;
    handleDelete: (id: number) => void;
    handlePageChange: (event: ChangeEvent<unknown>, page: number) => void;
};

export const AssignTable: FC<IProps> = ({ assignList, handlePageChange, pageAmount, page, scrollRef, handleDelete, sortedBy }) => {
    const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const styles = useMemo(() => getStyles(lgDown), [lgDown]);

    return (
        <>
            <Box mt={2}>
                <AssignTableHead sortedBy={sortedBy} />
                <Divider />
                <Box sx={styles.tableWrapper} ref={scrollRef}>
                    <Table>
                        <AssignTableBody
                            sortedBy={sortedBy}
                            assignList={assignList}
                            handleDelete={handleDelete}
                        />
                    </Table>
                </Box>
                <Stack direction='row' justifyContent='center' sx={styles.paginationWrapper}>
                    <Pagination
                        page={page}
                        count={pageAmount || 1}
                        color="primary"
                        onChange={handlePageChange}
                    />
                </Stack>
            </Box>
        </>
    )
};